import { useEffect, useState } from 'react';
import API from '../configs/api';

interface IDetailMemberQuery {
    userId: string,
    currentPage?: number,
    limit?: number,
    path?: string,
    isTotalPage?: boolean
}

const useDetailMember = (query: IDetailMemberQuery) => {
    const { currentPage, limit, userId, path, isTotalPage }: any = query;
    const [list, setList] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [totalList, setTotalList] = useState(0);
    const [totalPage, setTotalPage] = useState(0);

    const fetchData = async () => {
        setLoading(true);
        const payload = {
            params: `${path}`,
            query: { user_id: userId, page: currentPage, limit: limit || 5 }
        };
        API.memberDetail(payload).then((result: any) => {
            if (result.total_data) {
                setTotalList(result.total_data);
            }
            if (isTotalPage && result.total_page) {
                setTotalPage(result.total_page);
            }
            setList(result.data);
            setLoading(false);
        });
    };

    useEffect(() => {
        fetchData();
        return () => {
            setList([]);
            setLoading(false);
            setTotalList(0);
        };
    }, [currentPage, limit, path]);

    return { list, loading, totalList, totalPage } as const;
};

export default useDetailMember;
